const en = {
	common: {
		submit: 'Submit',
		create: 'Create',
		registerHere: 'Register here.',
		email: 'Email',
		password: 'Password',
		login: 'Login',
		corporate: 'Corporate',
		individual: 'Individual',
		loginHere: 'Login here.',
		yes: 'Yes',
		back: 'Back',
		phone: 'Phone',
		location: 'Location',
		edit: 'Edit',
		userType: 'User Type',
		save: 'Save',
		cancel: 'Cancel',
		others: 'Others',
		no: 'No',
		status: 'Status',
		add: 'Add',
		enterHere: 'Enter here',
		next: 'Next',
		close: 'Close',
		select: 'Select',
		reject: 'Reject',
		consent: 'Consent',
		check: 'Check',
		search: 'Search',
		available: 'Available',
		details: 'Details',
		oldAndNewSameValue: 'New value(s) must have difference value with existing values',
		validate: {
			onlyCharacters: 'Numbers are not allowed',
			noAvailable: 'No available documents yet'
		}
	},
	header: {
		mortgageDeals: 'Mortgage Deals',
		contactUs: 'Contact Us',
		home: 'Home'
	},
	contact: {
		title: 'Contact Us',
		headerLine1: 'Propcap Technologies Limited, founded in 2020.',
		headerLine2: 'The First Cross-Border Real Estate Secured Lending Platform in Asia.',
		headerLine3:
			'PropCap recognises that the mortgage application, often due to old banking structures and approval processes, is the biggest challenge for overseas property buyers. PropCap breaks through from tradition, adding innovative visions and solutions to our clients. Our state-of-the-art technology improves the overseas property loan application experience and provides alternative capital solutions to overseas assets holders.'
	},
	login: {
		welcome: {
			title: 'The Future of Mortgage',
			shortDesc: 'Present by PropCap. Asia’s First Cross-Border Mortgage Match-Lending Platform.',
			longDesc1:
				'We are here to make mortgage easy for overseas property buying journey, meanwhile creating alternative opportunities for investors in the fast-changing world.',
			longDesc2: 'Free from hassle and uncertainty. Everything is in our safe hands. Go beyond with us now!'
		},
		form: {
			title: 'Login',
			dontHaveAccount: 'Don’t have an account? ',
			forgotPassword: 'Forgot password'
		},
		formForgotPassword: {
			title: 'Forgot Password',
			subTitle: 'Enter your registered email',
			placeholderInput: 'Enter here',
			resetPassword: 'Request password reset',
			backToLogin: 'Back to Login',
			invalidLink: 'Your link is expired',
			emailNotExisted: 'The email is not existed'
		},
		formCheckEmail: {
			title: 'Check your email',
			subTitle: 'We have sent a password resetting link to your email.'
		},
		formNewPassword: {
			title: 'New Password',
			subTitle: 'Create a new password',
			createNewPassword: 'Create new password',
			reEnterPassword: 'Re-enter new password',
			continueButton: 'Continue'
		},
		changePassWord: {
			title: 'Change Password',
			describe:
				'You can always change your password for security reasons or reset your password in case you forgot it.',
			currentPassword: 'Current Password',
			newPassword: 'New Password',
			confirmNewPass: 'Confirm New Password',
			reEnterNewPass: 'Re-enter New Password',
			buttonChangePass: 'Update Password'
		},
		confirmChangePassword: {
			title: 'Confirmation',
			content: 'Are you sure to update your password?'
		}
	},
	selectAccount: {
		title: 'Select User Type',
		alrHadAccount: 'Already Registered? ',
		corporateConfirm:
			'Only individual registered user can become a Guarantor, are you sure to proceed as a corporate registered user?'
	},
	registration: {
		title: 'Registration',
		firstName: 'First Name',
		middleName: 'Middle Name',
		lastName: 'Last Name',
		passwordConfirmation: 'Password Confirmation',
		receiveEmail: 'I wish to receive direct marketing from Propcap.',
		createMyAccountBtn: 'Create My Account',
		companyName: 'Company Name',
		countryOfTaxResidence: 'Country of Tax Residence',

		tncConfirmText: 'I HAVE READ, UNDERSTOOD AND AGREED THE ABOVE INFORMATION',
		validation: {
			firstNameRequired: 'Please input your first name',
			middleNameRequired: 'Please input your middle name',
			lastNameRequired: 'Please input your last name',
			emailRequired: 'Please input your email',
			passwordRequired: 'Please input your password',
			passwordConfirmationRequired: 'Please input your password confirmation',
			companyNameRequired: 'Please input your Company name',
			passwordAndConfirmationPasswordNotMatched: 'Password and password confirmation are not matched',
			currentPasswordAndnewPasswordSame: 'The New password can not be the same as the Current password.',
			passwordPolicy:
				'Min length of 8 characters, must contain at least 1 capital letter and 1 non-capital letter and 1 special character and 1 number',
			wrongEmailFormat: 'Please correct the email format',
			inputOnlyNormalCharacter: 'Please input characters only',
			inputOnlyAlphabet: 'Please enter alphabets only'
		},
		tcn: {
			page1: {
				title: 'Platform Usage Disclaimer',
				disclaimerTitle: 'DISCLAIMER',
				disclaimerItem1:
					'Please read this disclaimer (“Disclaimer”) and also the terms and conditions (“Terms and Conditions”) on this website (“Website”) carefully before using this Platform. By continuing to use this Platform, each subscriber, user and/or recipient of the services irrevocably and unconditionally accepts and agrees to be bound by this Disclaimer and the Terms and Conditions. We reserve the right to modify this Disclaimer and the Terms and Conditions on this Website at any time without prior notice to or consent from any user to this Platform, and such modification shall be effective immediately upon either posting on the Website or notifying you as the case may be.',
				disclaimerItem2:
					'Your use of this Platform is wholly at your own risk. This Platform is provided on an “as is” basis with no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability or completeness of any information and its functionality on this Platform though care has been taken in the information provided, and disclaims any loss arising from any part of such information.',
				disclaimerItem3:
					' The information, materials and opinions contained in this Platform and/or the Website are for general information purposes only, and should not be construed as legal, accounting, financial or tax advice or opinion on any specific facts or circumstances and should not be relied upon in that regard. You must not rely on any statement, materials or information published on this Platform and/or the Website or obtained through this Platform and/or the Website without taking independent legal or professional advice in relevant jurisdiction(s). We reserve the right to correct any errors or omissions in this Platform and/or the Website. Neither we nor any affiliate, subsidiary, officer or agent of us accepts any responsibility for any loss which may arise from reliance on information or materials published on this Platform and/or the Website.',
				overInternetTransmission: 'TRANSMISSION OVER THE INTERNET',
				overInternetTransmissionItem1:
					'We make our best effort to ensure the security of your data transmitted via this Platform by the use of encryption technologies. Additionally, by using this Platform, you acknowledge and agree that internet transmissions are never completely private or secure. You understand that any messages or information you send using this Platform may be read or intercepted by others, even if there is a special notice that a particular transmission is encrypted.',
				overInternetTransmissionItem2:
					'Communications via the internet may be affected by factors beyond our reasonable control, including but not limited to a breakdown or failure of communication facilities, inherent technological deficiencies, network traffic congestion or any blockage or interruption, delay, corruption or interception of such communication.',
				overInternetTransmissionItem3:
					'We cannot guarantee that no viruses or other contaminating or destructive properties will be transmitted or that no damage will occur to your computer, mobile phone or other devices (“device”) for accessing our Platform. We are not responsible for any losses or damages that you may suffer as a result of this. You are solely responsible for ensuring adequate protection and back-up of the device and/or any data within such device, taking reasonable and appropriate precautions against computer viruses or other destructive properties and for preventing the transmission of any computer viruses to your device.',
				internetLimitationTitle: 'LIMITATIONS OF THE INTERNET TECHNOLOGY',
				internetLimitationDesc:
					'While we make reasonable efforts to provide the services to you through this Platform, you acknowledge that the internet is a complex and rapidly advancing technology. Accordingly, while we are committed to developing its internet capabilities:',
				internetLimitationItem1: 'The services may not meet all your requirements or expectations;',
				internetLimitationItem2:
					'Access to this Platform may be subjected to interruptions, failures of hardware or software, errors, transmission blackouts, delayed transmissions due to internet traffic or incorrect data transmission due to the public nature of the internet, system failure or upgrades or maintenance or for other reasons;',
				internetLimitationItem3: 'Features or functionality of this Platform may be changed from time to time;',
				internetLimitationItem4:
					'Use of the services through this Platform may be restricted by the type, specification and/or configuration of your device.',
				suspensionAndTerminationTitle: 'SUSPENSION AND TERMINATION',
				suspensionAndTerminationDesc:
					'We may deactivate or suspend the services provided by this Platform and/or the Website or any part thereof, with or without notice to you, to carry out system, maintenance, upgrading, testing and/or repairs; and/or limit or suspend your access to this Platform and/or the Website with or without notice to you if we are of the opinion that such action is appropriate as a result of your use of this Platform and/or the Website.',
				miscellaneousTitle: 'MISCELLANEOUS',
				miscellaneousDesc:
					'We shall have the right to sub-license, sub-contract, assign or transfer all or any rights and obligations under this Disclaimer to any third party at our sole and absolute discretion. This Disclaimer shall be governed by Hong Kong law. You agree that any action arising under this Disclaimer shall be subject to the non-exclusive jurisdiction of Hong Kong courts.',
				tcnUpdateAt:
					'Note: In the event of any difference between the Chinese and English versions, English version shall prevail.'
			},
			page2: {
				title: 'Terms and Conditions',
				generalTitle: 'General',
				generalItem1:
					'By accessing this website, you agree to the terms and conditions set out below (“Terms and Conditions”).',
				generalItem2:
					'These Terms and Conditions constitute a legally binding agreement made between you, whether personally or on behalf of an entity (“you”), and the Company.',
				generalItem3:
					'These terms and conditions will be updated from time to time at the Company’s sole discretion without prior notice to you. Your access to it signifies your acceptance to these terms and conditions and agreement to be bound by them.',
				generalItem4:
					'The information in this website is not intended to provide professional advice. It is strongly recommended that specific advice should be sought wherever applied. Also, the information provided on this website is not intended for distribution to or use by any person or entity in any jurisdiction or country where such distribution or use would subject us to any registration requirement within such jurisdiction or country. Accordingly, those persons or entities who choose to access this website from such locations do so on their own initiative and are solely responsible for compliance with local laws, if and to the extent local laws are applicable.',
				generalItem5:
					'Any information, products or services presented in this website may be withdrawn or revised at any time without prior notice and at the sole discretion of the Company. The availability and eligibility of products or services offered are subjected to the final and absolute discretion of the Company. ',
				userRepresentationTitle: 'User Representations',
				userRepresentationDesc: 'By using this website, you represent and warrant that:',
				userRepresentationItem1:
					'(1) all registration information you submit will be true, accurate, current, and complete;',
				userRepresentationItem2:
					'(2) you will maintain the accuracy of such information and promptly update such registration information as necessary;',
				userRepresentationItem3:
					'(3) you have the legal capacity and you agree to comply with these Terms and Conditions;',
				userRepresentationItem4: '(4) you are not under the age of 18;',
				userRepresentationItem5:
					'(5) you are not a minor in the jurisdiction in which you reside, or if a minor, you have received parental permission to use this website;',
				userRepresentationItem6:
					'(6) you will not access this website through automated or non-human means, whether through a bot, script, or otherwise;',
				userRepresentationItem7: '(7) you will not use this website for any illegal or unauthorized purpose;',
				userRepresentationItem8: '(8) your use of this website will not violate any applicable law or regulation.',
				userRepresentationItem9:
					'If you provide any information that is untrue, inaccurate, not current, or incomplete, we have the right to suspend or terminate your account and refuse any and all current or future use of this website (or any portion thereof).',
				userRegistrationTitle: 'User Registrations',
				userRegistrationDesc:
					'You may be required to register with this website. You agree to keep your password confidential and will be responsible for all use of your account and password. We reserve the right to remove, reclaim, or change a username you select if we determine, in our sole discretion, that such username is inappropriate, obscene, or otherwise objectionable.',
				limitedLiabilitiesAndNoWarrantyTitle: 'Limited Liabilities and No warranty',
				limitedLiabilitiesAndNoWarrantyDesc:
					'Your access to and use of our services is at your sole risk and is provided on an “as is” basis. The Company and its related companies, officers, directors, employees, agents, representatives, partners, affiliates make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability or completeness of any information on this website though care has been taken in the information provided, and disclaims any loss arising from any part of such information.',
				internetCommunicationTitle: 'Internet Communications',
				internetCommunicationDesc:
					'The Company accept no liability for any damages, loss or corruption of any communication due to the failure, interruption, transmission delay or incorrect data transmission through internet. Under no circumstances will the Company be liable for any loss or damages of any kind incurred from accessing this website.',
				personalInfoTitle: 'Personal Information and Data Collection',
				personalInfoDesc:
					'All your personal information or data collected by the Company from this website may be used, disclosed, transferred for the purposes and to the persons in accordance with the Company’s Personal Data Privacy Policy.',
				governingLawTitle: 'Governing Law',
				governingLawDesc:
					'These Terms and Conditions and your use of the website are governed by and construed in accordance with the laws of Hong Kong applicable to agreements made and to be entirely performed within Hong Kong, without regard to its conflict of law principles.',
				disputeResolution: 'Dispute Resolution',
				disputeResolutionItem1:
					'Any legal action of whatever nature brought by either you or us (collectively, the “Parties” and individually, a “Party”) shall be commenced or prosecuted in Hong Kong, and the Parties hereby consent to, and waive all defenses of lack of personal jurisdiction and forum non conveniences with respect to venue and jurisdiction in Hong Kong.',
				electronicCommunicateTitle: 'Electronic Communications, Transactions, and Signatures',
				electronicCommunicateItem1:
					'Visiting the website, sending us emails, and completing online forms constitute electronic communications. You consent to receive electronic communications, and you agree that all agreements, notices, disclosures, and other communications we provide to you electronically, via email and on the website, satisfy any legal requirement that such communication be in writing.',
				electronicCommunicateItem2:
					'You hereby agree to the use of electronic signatures, contracts, orders, and other records, and to electronic delivery of notices, policies, and records of transactions initiated or completed by us or via this website.',
				electronicCommunicateItem3:
					'You hereby waive any rights or requirements under any statutes, regulations, rules, ordinances, or other laws in any jurisdiction which require an original signature or delivery or retention of non-electronic records, or to payments or the granting of credits by any means other than electronic means.',
				miscellaneousTitle: 'Miscellaneous',
				miscellaneousItem1:
					'These Terms and Conditions and any policies or operating rules posted by us on the website constitute the entire agreement and understanding between you and us. Our failure to exercise or enforce any right or provision of these Terms and Conditions shall not operate as a waiver of such right or provision.',
				miscellaneousItem2:
					'These Terms and Conditions operate to the fullest extent permissible by law. We may assign any or all of our rights and obligations to others at any time. We shall not be responsible or liable for any loss, damage, delay, or failure to act caused by any cause beyond our reasonable control.',
				note: 'Note: In the event of any difference between the Chinese and English versions, English version shall prevail.'
			},
			page3: {
				title: 'Personal Data Privacy Policy',
				desc: 'The Company will comply with the requirements of the Personal Data (Privacy) Ordinance (Cap. 486, Laws of Hong Kong) (the “Ordinance”).',
				informationCollectionTitle: 'Information Collection',
				informationCollectionItem1:
					'The Company will collect your data when you interact with us. We may store your data locally, overseas or in the cloud. We will keep your data safe in accordance with Laws of Hong Kong. We will use your data to send you direct marketing if you have consented to it.',
				informationCollectionItem2:
					'We may use the personal data collected for the purpose set out in the Personal Information Collection Statement (see below). The use and disclosure of personal data and your right to access or correct your personal data held by the Company are also set out in the Personal Information Collection Statement (see below).',
				informationCollectionItem3:
					'We will take practical steps to ensure that your personal data will not be kept longer than necessary and that we will comply with all regulatory requirements in Hong Kong about the retention of personal data.',
				useOfCookiesTitle: 'Use of Cookies',
				useOfCookiesItem1:
					'When you visit the Company website, communicating with chatbox, cookies may be placed on your device. Cookies may also be placed by third parties on behalf of the Company. No personal contact information of you is collected or shared by third parties with the Company as a result of the use of cookies.',
				useOfCookiesItem2:
					'If you do not what to be tracked by the use of cookies, you can choose to ‘not accept’ cookies by changing the settings on your web browser. However, if you block all cookies, including strictly necessary cookies, some functions on the website may not be functioning properly.',
				useOfCookiesItem3: 'This policy also forms part of the Terms and Conditions of the Company website.',
				personalInformationCollectionStatementTitle: 'Personal Information Collection Statement',
				personalInformationCollectionStatementItem1:
					'This Statement applies to the Company and its group companies (“the Group”) and all visitors and prospective and existing customers (“you”) of the Group.',
				personalInformationCollectionStatementItem2:
					'You agree that all personal information relating to you collected by the Group from this website from time to time may be used and disclosed if necessary according to the Group’s current Personal Data Privacy Policy.',
				personalInformationCollectionStatementItem3: 'Purpose of Collection',
				personalInformationCollectionStatementItem4:
					'The Group can collect, use and transfer personal information for any and all of the following purposes:',
				personalInfoCollectionPurposeItem1: 'processing your application and other related services or products;',
				personalInfoCollectionPurposeItem2: 'facilitating payment arrangements or instructions;',
				personalInfoCollectionPurposeItem3: 'conducting identity and/or credit checks and/or debt collection;',
				personalInfoCollectionPurposeItem4: 'compilation of statistics and research analysis;',
				personalInfoCollectionPurposeItem5:
					'communication with customers and prospective customers of the Group or Related Parties;',
				personalInfoCollectionPurposeItem6:
					'compliance with any disclosure requirements required by law and regulation;',
				personalInfoCollectionPurposeItem7: 'any other purposes as notified to you at the time of collection; and',
				personalInfoCollectionPurposeItem8:
					'conduct marketing and/or direct marketing activities of any other related services or products relating to us and/or Related Parties, subject to applicable laws;',
				personalInfoCollectionPurposeItem9:
					'improving and furthering the provision of services by entities of the Group, subject to applicable laws;',
				personalInfoCollectionPurposeItem10: 'fulfilling any other purposes relations to the above-mentioned purposes.',
				useOfPersonalDataTitle: 'Use of Personal Data',
				useOfPersonalDataItem1:
					'Subject to all relevant laws and the terms herein, in respect of Direct Marketing (as defined in “Personal Data (Privacy) Ordinance” and/or any amendments thereof), the following provisions apply:',
				useOfPersonalDataAppliedItem1:
					'the Group intends to use and/or transfer your personal data to members of the Group, its business partners, Related Parties, and affiliates for Direct Marketing purposes pursuant to the terms herein for gain to pursue business cooperation or opportunities concerning financial, insurance, mandatory provident and related wealth management products or services;',
				useOfPersonalDataAppliedItem2:
					'the Group will not use your personal data for direct marketing purposes unless we have received your consent (which includes an indication of no objection);',
				useOfPersonalDataAppliedItem3:
					'the Group may use any of the following personal data for marketing products or services offered by the Group or its business partners:',
				useOfPersonalDataAppliedItem31:
					'your name, your residential address, your mobile number, your residential phone number and your email address',
				useOfPersonalDataAppliedItem32:
					'your personal data will be used for marketing and direct marketing of any of the Group’s products or services via all means of transmission.',
				informPropCap:
					'You may inform Propcap if you wish to opt-out of our use of your personal data for any of the Direct Marketing purposes or if you wish to opt-out of any kinds or means of transmission regarding Direct Marketing.',

				contactOfficer: 'Data Protection Officer',
				contactDepart: 'Propcap Technologies Limited',
				contactAddr: 'Room 2057, 20/F., Lee Garden 3,',
				contactStreet: '1 Sunning Road, Causeway Bay,',
				contactHK: 'Hong Kong'
			}
		},
		otp: {
			title: 'Activate your PropCap Account',
			msg: 'Thank you for registering for Propcap Client Portal. Please input the OTP sent to your registered email.',
			otpLabel: 'One Time Password(OTP)',
			send: 'Send',
			resend: 'Resend OTP',
			otpRequired: 'Please input the OTP sent to your registered email.',
			titleOtpLogin: 'One Time Password (OTP)',
			msgOtpLogin: 'Please input the OTP sent to your registered email.',
			otpExpiresIn: 'OTP Expires in',
			minutes: 'Minutes'
		}
	},
	dashboard: {
		menu: {
			profile: {
				title: 'Profile'
			},
			account: 'Account',
			home: 'Home',
			logout: 'Logout',
			changeRequest: 'Change Request',
			investment: 'Investment',
			mortgageDeal: 'Mortgage Deals',
			guarantee: 'Guarantee',
		},
		account: {
			basicInformation: 'Basic Information',
			notiTitle: 'Notifications',
			billingAndAccount: 'Billing and account',
			txnEmailAndAccountNoti: 'Transactional emails and account notifications',
			legallyObligated: 'Legally Obligated',
			changePassword: 'Change Password',
			changePasswordDes:
				'You can always change your password for security reasons or reset your password in case you forgot it.',
			currentPass: 'Current Password',
			newPass: 'New Password',
			confirmNewPass: 'Confirm New Password',
			updatePassBtn: 'Update Password'
		},
		emptyDasboard: {
			dontHaveDashboard: 'You don’t have a dashboard now. Become a Funder or Borrower to view your own dashboard.',
			becomeA: 'Become a',
			becomeAFunder: 'Funder',
			becomeBorrower: 'Borrower',
			becomeBorrowerGuarantor: 'Borrower / Guarantor',
			becomeFunder: 'Become a Funder',
			allWasApproved: 'Invest a deal or Submit a mortgage application now!',
			wasApprovedBorrower: 'Submit a mortgage deal application now!',
			wasApprovedFunder: 'Invest a deal application now!',
			BecomeAFunderOrBorrower: 'Become a Funder or Borrower now.',
			BecomeAFunderOrBorrowerGuarantor: 'Become a Funder or Borrower / Guarantor now.',
			funderOrBorrowerRejected: 'Become a Funder or Borrower to invest a mortgage deal.'
		},
		accountInformation: {
			header: 'Account Information',
			title: 'Title',
			personalDetail: 'Personal Details',
			chineseName: 'Chinese Name',
			gender: 'Gender',
			dob: 'Date of Birth',
			pob: 'Place of Birth',
			hkId: 'HKID No.',
			chineseId: 'Chinese ID No.',
			passport: 'Passport No. / Driver License No. with Photo.',
			nationality: 'Nationality',
			countryOfTax: 'Country of Tax Residence',
			chineseIdEffectiveDate: 'Chinese ID Effective Date',
			chineseIdExpiryDate: 'Chinese ID Expiry Date',
			chineseIDRegistrationAddress: 'Address declared upon Chinese ID registration',
			bankCardNumber: 'Bank Card Number',
			sourceOfFund: 'Source of Fund',
			contactDetail: 'Contact Details',
			officePhoneNo: 'Office Phone Number',
			mobilePhone: 'Mobile Phone Number',
			residentAddress: 'RESIDENTIAL ADDRESS',
			adrLine: 'Flat, Floor & Building Name',
			street: 'Street No. & Street Name',
			district: 'District/Province',
			country: 'Country',
			zipCode: 'ZIP Code/Post Code',
			liveYears: 'How long have you lived in the above address?',
			year: 'Years',
			mailingAddress: 'MAILING ADDRESS (IF NOT AT THE SAME ADDRESS)',
			needChangeRq: 'Please submit a change request if you want to edit.',
			tabAccount: 'Account Information',
			tabDocument: 'Document List',
			tabPaymentHistory: 'Payment History',
			maritalStatus: 'Marital Status',
			sourceOfFunds: 'Source of Fund (can choose more than one)',
			emailAddress: 'E-mail Address',
			residentAddressReg: 'Residential Address',
			mailingAddressReg: 'Mailing Address (If not at the same address)',
			positionInCompany: 'Position in the Company',
			employmentDetails: 'Employment Details',
			employmentStauts: 'Employment Status',
			employerName: 'Employer Name',
			natureOfBusiness: 'Nature of Business'
		},
		documentList: {
			BorrowerGuarantorRequest: {
				title: 'Borrower / Guarantor Request.',
				supportingDocumentLevelForBorrowerRequest: 'Supporting Document Level For Borrower Request',
				companyLevelDocumentLevelForBorrowerRequest: 'Company Level Document Level For Borrower Request',
				borrowerServiceAgreement: 'Borrower Service Agreement',
				borrowerOrGuarantorRequest: 'Borrower / Guarantor Request.'
			},
			funderRequest: {
				title: 'Funder Request',
				supportingDocumentLevelForFunderRequest: 'Supporting Document Level For Funder Request',
				companyLevelDocumentLevelForFunderRequest: 'Company Level Document Level For Funder Request',
				funderServiceAgreement: 'Funder Service Agreement'
			},
			platformUsageDisclaimer: 'Platform Usage Disclaimer',
			termsAndConditions: 'Terms and Conditions',
			PersonalDataPrivacyPolicy: 'Personal Data Privacy Policy',
			declarationForm: 'Declaration Form',
			personalInformationCollectionStatement: 'Personal Information Collection Statement',
			professionalInvestorNotice: 'Professional Investor Notice',
			message: {
				NoAvailableDocumentsYet: 'No available documents yet'
			}
		},
		funderWallet: {
			title: 'Funder Wallet',
			tabHeader: 'Funder Wallet',
		},
		investmentList: {
			header: 'Investment List',
			tabHeader: 'Investment List',
		},
		crPage: {
			tab: {
				form: 'Change Request Form',
				history: 'Change Request History'
			}
		}

	},
	httpResponse: {
		incorrectLoginCredential: 'Login Failed: Your user ID or password is incorrect',
		otpNotMatched: 'Verification Failed: Your one time password is incorrect',
		otpExpired: 'OTP is Expired',
		emailNotExist: 'Your email does not exist',
		unknown: 'Unknown Error',
		currentPasswordNotMatched: 'Current Password is incorrect',
		emailAlreadyExisted: 'Email already exist',
		badRequest: 'Save Failed: One or more fields have an error. Please check and try again',
		tokenInvalid: 'Your session was expired.',
		saveAccountSuccess: 'Upload failed',
		sameOldPassword: 'Your new password cannot be the same as your current password',
		userIsInactive: 'Your account is inactive',
		selfieImageNotClear: 'Selfie Image Not Clear.',
		selfieImageWearingSunGlasses: 'Selfie Image Wearing Sunglasses.',
		selfieImageQualityTooLow: 'Selfie Image Quality Too Low.',
		noFaceDetected: 'No Face Detected.',
		invalidSelfieImage: 'Invalid Selfie Image.',
		invalidBorrowerOnboardingRequest: 'Invalid Borrower Onboarding Request.',
		mortgageDealNotFound: 'Mortgage Deal Not Found.',
		guarantorNotConsentedYet: 'Guarantor Not Consented Yet.',
		guaranteeCouldNotBecomeTheirOwnGuarantor: 'You could not be come guarantor for your own deal.',
		pleaseSubmitTheGuarantorRequest: 'Please submit Guarantor request.',
		invitationLinkExpired: 'Guarantor invitation link is expired.',
		corporateCantBecomeTheGuarantor: 'Corporate can not become the Guarantor.',
		theLinkIsNoLongerValid: 'The link is no longer valid.',
		companyCouldNotBecomeGuarantor: 'Corporate account could not become guarantor',
		currentLoggedInIsNotCorrespondingGuarantor: 'The current logged in account is not the corresponding guarantor, please login the corresponding guarantor account and access the link again',
		tooManyFailedLogInAttempt: 'Your account has been locked due to too many failed login attempts. Please contact the system administrator to unlock your account.',
	},
	feedback: {
		resentOtpSuccess: 'Verification code was resent successfully',
		otpVerifiedSuccess: 'You have been verified successfully',
		otpVerifiedError: 'Verification Failed: Your one time password is incorrect',
		loginSuccess: 'You are successfully logged in',
		registrationSuccess:
			'Your registration has been successfully completed, You have just been sent an email containing account activation instructions.',
		changePassSuccess: 'The Password is reset successfully',
		forgotLinkSent: 'An reset password link was sent to you mailbox, Please check',
		updateBasicInfoSuccess: 'Information success',
		saveAccountSuccess: 'Success. Your Account Detail application has been saved',
		saveEmploymentDetailSuccess: 'Success. Your Employment Detail application has been saved',
		fileUploadSuccess: 'File uploaded',
		fileDeleteSuccess: 'File deleted',
		saveLoanLendingSuccess: 'Success. Your Loan lending criteria has been saved',
		saveBankAccountSuccess: 'Success. Your Your Bank Account has been saved',
		saveFinancialDetailsSuccess: 'Success. Your Financial Details has been saved',
		saveOtherDetailsSuccess: 'Success. Your Other Details has been saved',
		saveDraftSuccess: 'Success. Your Funder application has been saved as draft',
		saveDraftBorrowerSuccess: 'Success. Your Borrower application has been saved as draft',
		submitSuccess: 'Success. Your Funder application has been submitted',
		firstNameNotMatched: 'Failed, First Name is not matched',
		lastNameNotMatched: 'Failed, Last Name is not matched',
		maxFileSizeReached: 'The uploaded file exceeds maximum limit, file size need to be smaller than 5 mb.',
		minFileSizeReached: 'The uploaded file is too small, file size need to be between 50 kb and 5 mb.',
		maxFileSizeReactedBetween: 'The uploaded file exceeds maximum limit, file size need to be between 50 kb and 5 mb.',
		totalFileSizeReached: 'Upload failed, Total file size exceed (100MB)',
		middleNameNotMatched: 'Failed, Middle Name is not matched',
		pleaseInputRequiredFiles: 'Please Upload required files',
		companyInfoSaved: 'Success. Your Company Details has been saved',
		otherDetailSaved: 'Success. Your Other details information has been saved',
		submitBorrowerSuccess: 'Success. Your Borrower application has been submitted',
		guarantorConsentInvitationSuccess: 'Success, Consented guarantee',
		guarantorRejectInvitationSuccess: 'Success, Rejected guarantee',
		guarantorConfirmInvitationSuccess: 'Success, Confirmed guarantor request'
	},
	onboarding: {
		saveAndNext: 'Save And Next',
		saveAsDraft: 'Save As Draft',
		funder: {
			accountTitle: 'Account Details'
		},
		cancel: {
			stayBtn: 'Stay on this page',
			leave: 'Leave',
			title: 'Save before you leave this page',
			description: 'Are you sure you want to leave this page ?',
			description1: 'You have unsaved changes. If you leave the page, these changes will be lost.'
		},
		request: {
			employmentDetail: 'Employment Details',
			loanCriteria: 'Loan Lending Criteria',
			bankInformation: 'Bank Account Information',
			supportDoc: 'Supporting Document',
			employment: {
				selectedCurrency: 'Currency for following details',
				currency: 'Please choose a currency for following details',
				employmentType: 'Employment Type',
				employed: 'Employed',
				selfEmployed: 'Self-employed',
				retired: 'Retired',
				others: 'Others',
				employerName: 'Employer Name',
				natureOfBiz: 'Nature of Business',
				occupation: 'Occupation / Position',
				employerAddress: 'Employer Address',
				employmentStatus: 'Employment Status',
				esFullTime: 'Full Time',
				esPartTime: 'Part Time',
				esContract: 'Contract',
				esCasualTemp: 'Casual/Temp',
				employerPhone: 'Employer Phone',
				annualSalary: 'Annual Salary / Net Profit',
				employersAddress: 'Employer’s Address',
				employerType: 'Employer Type'
			},
			loanLendingCriteria: {
				propType: 'Property Type (can choose more than one)',
				propTypeFlat: 'Flat / Condo',
				propTypeDetached: 'Detached',
				propTypeSemiDetached: 'Semi-Detached',
				propTypeTerracedHouse: 'Terraced House',
				propTypeHMO: 'HMO',
				propTypeLand: 'Land',
				propTypeCommercial: 'Commercial',
				totalCommittedLoanAmount: 'Total Committed Loan Amount',
				maxLoanPerDeal: 'Maximum Loan Amount Per Deal',
				proposedLoanCurrency: 'Proposed Loan Currency (can choose more than one)',
				propCountryPreference: 'Property Country Preference (can choose more than one)',
				minLoanPeriod: 'Minimum Loan period',
				maxLoanPeriod: 'Maximum Loan period',
				interestPaymentPeriod: 'Interest Payment Period',
				minimumExpectedInterestRate: 'Minimum Expected Interest Rate/ annual',
				months: 'Months',
				allOfAbove: 'All of above',
			},
			bankAccount: {
				bankName: 'Bank Name',
				swiftCode: 'Swift Code',
				bankAddress: 'Bank Address',
				accountName: 'Account Name',
				accountNumber: 'Account Number'
			},
			nationality: {
				title: 'Nationality',
				passportNo: 'Passport No',
				hkIdNo: 'HKID No',
				chineseIdNo: 'Chinese ID No',
				chineseIdEffectiveDate: 'Chinese ID Effective Date',
				chineseIdExpiryDate: 'Chinese ID Expiry Date',
				chineseIdRegistrationAddress: 'Address Chinese ID Registration',
				bankCardNumber: 'Bank Card Number'
			},
			supportingDocument: {
				title: 'Personal Level',
				identityFiles: 'Photo of current HKID/Passport/Driver License with Photo',
				selfie: 'Selfie',
				proofOfIncome: 'Proof of Income',
				sourceOfWealth: 'Source of Wealth',
				residentialAddrProof: 'Residential Address Proof',
				otherDocs: 'Other Documents (if any)',
				bankStatement: 'Bank Statements for the past 3 months',
				reservationFormOrMm: 'Reservation Form or Memorandum of Sale',
				contractOfExchange: 'Contract of Exchange',
				titleFloorPlan: 'Title Floor Plan',
				ukFinance: 'U.K. Finance Disclosure Form',
				proofOfDeposit: 'Proof of Deposit',
				surveyorReport: 'Surveyor Report',
				reportOnTitle: 'Report on Title / Title Deed',
				existingMortgage: 'Existing Mortgage Statements/Rent Roll',
				existingTenancy: 'Existing Tenancy Agreement/Leasing Contract',
				energyPerformance: 'Energy Performance Certificate',
				ews1Form: 'EWS1 Form',
				validationReport: 'Valuation Report',
				residentHint:
					'Bank statements or utility bills within 3 months from date of application and P. O. Box Address is not accepted',
				proofOfIncomeHint: 'Latest 2 years’ tax return, latest 3 month’s salary advice/pay slips',
				sourceOfWHint: 'Bank statement or other asset proof documents',
				chineseIdImgFront: 'Front of Chinese ID',
				chineseIdImgBack: 'Back of Chinese ID',
				bankCardImg: 'Bank Card Copy'
			},
			companyDocuments: {
				title: 'Company Level',
				iconHint:
					'All relevant documents to be certified by a public accountant, solicitor or an embassy, consulate or high commission of the country that has issued the documentary evidence of identity',
				certificateOfIncorporation: 'Certificate of Incorporation',
				businessRegistrationCert: 'Business Registration Certificate',
				latestAnnualReturn: 'Latest Annual Return (NAR1)',
				certificationOfIncumbency: 'Certificate of Incumbency',
				latestAudited1: 'Latest audited financial statements within 3 years',
				latestAudited2: '(for newly incorporated companies, an opening balance sheet signed by the Directors)',
				groupOwnership: 'Group ownership and structure chart',
				signedBoard: 'Signed board resolution authorizing mortgage arrangement',
				signedBoard1: 'i) the Trust arrangement',
				signedBoard2: 'ii) person(s) giving instructions and',
				signedBoard3: 'iii) authorized signatory list (including signatory powers)',
				otherDocs: 'Other Documents (if any)'
			},
			financialDetails: {
				title: 'Financial Details',
				sourceOfIncome: 'Source of Income',
				wages: 'Wages',
				interestDividends: 'Interest/Dividends',
				spouse: 'Spouse / Partner Income',
				rentalIncome: 'Rental Income',
				investmentIncome: 'Investment Income',
				others: 'Others',
				yearly: 'Yearly regular expenditures',
				residentialInvestmentMortgage: 'Residential / Investment Mortgages',
				annuityRent: 'Annuity / Rent',
				personalFinance: 'Personal Finance Loans / Installment Purchases',
				household: 'Household Expenses',
				totalYearsExp: 'Total Yearly Expenditures',
				yearlyDisposableIncome: 'Yearly Disposable Income',
				realEstateAsset: 'Real Estate Asset and Liabilities',
				address: 'Address',
				marketValue: 'Market Value',
				mortgageAmt: 'Mortgage Amount',
				outstandingAmt: 'Outstanding Loan Amount',
				totalValue: 'Total Value',
				totalMortgage: 'Total Mortgage',
				totalOutstandingLoanAmt: 'Total Outstanding Loan Amount',
				personalBalanceSheet: 'Personal Balance Sheet',
				deposits: 'Deposits',
				bonds: 'Bonds',
				pensions: 'Pensions',
				stockFunds: 'Stocks/Funds',
				realEstates: 'Real Estates',
				totalAssets: 'Total Assets',
				personalLoans: 'Personal Loans',
				carLoans: 'Car Loans',
				taxLoans: 'Tax Loans',
				otherLoans: 'Other Loans',
				mortgage: 'Mortgage',
				totalLiabilities: 'Total Liabilities',
				netAssess: 'Net Assets',
				totalAnnualIncome: 'Total Annual Income'
			},
			otherDetails: {
				title: 'Other Details',
				individual: {
					question1:
						'Have you ever defaulted on any current or previous mortgage, rent or any payment and credit agreement?',
					question2: 'Have you ever had a debt penalty before?',
					question3: 'If you are a self-employed / holding director and your company has a history of debt penalties?',
					question4: 'Have you ever been bankrupt and entered into an agreement with a creditor?',
					question5: 'Have you ever been denied a mortgage/guaranteed loan for this property or any other property?',
					question6: 'Have you ever been punished for any criminal offence? (Excluding road traffic offences)',
					otherFill: 'Please fill in the details below.',
					title: 'Borrower/ Guarantor Credit History'
				},
				corporate: {
					title: 'Company Credit History',
					question1: 'Has the company ever had any delays in mortgage, loan or other credit agreements?',
					question2: 'Have any country courts previously ruled on the company?',
					question3: 'Has the company previously requested a liquidation?',
					question4: 'Has the company ever signed an agreement with a creditor before?',
					question5: 'Has this or any other property of the Company ever been denied a mortgage/guaranteed loan?',
					otherFill: 'Please fill in the details below.'
				}
			}
		},
		eform: {
			page1: {
				title: 'DECLARATION FORM',
				content:
					'PropCap is committed to protecting your personal data. This privacy policy (“Privacy Policy”) governs PropCap’s use of data collected by us, including any and all personal data. Personal data refers to information that relates to you and may identify you as an individual. We use your personal data in accordance with all applicable laws. To ensure compliance and to align with PropCap’s values of trust and transparency we have a team of privacy champions responsible for continuously implementing our global privacy program.<br/><br/> 1. Who we are, What we do, How you can contact PropCap, our DPO or the relevant authorities<br> Who we are:<br> This privacy policy applies to PropCap Inc., a Delaware, USA corporation with headquarters in New York; and its affiliated subsidiaries (collectively, “PropCap,” or “we“, “us“, “our“). We operate in various offices around the world and we partner with publishers and marketers across the globe.<br/><br/> Please note that PropCaps’ subsidiary Zemanta Inc has a separate Privacy Policy, which can be found here.<br/><br/>  What we do:<br/><br/> PropCap’s mission is to serve interesting recommendations to you based on what we believe are your interests. To achieve our mission we enter into agreements with:<br/> <br/> online publishers and partners who want to recommend relevant content to their readers (this is PropCap Engage);<br/> advertisers who want readers to view their content (this is PropCap Amplify); and<br/> third party partners who help us serve relevant recommendations.<br/> For further information on our Amplify (advertiser) services see here and our Engage (publisher) services see here.<br/><br/> How to contact us:<br/><br/> We regularly review our compliance with this Privacy Policy. Questions, comments and requests regarding this Privacy Policy are welcomed and should be addressed in the first instance to privacy@PropCap.com or by mail to PropCap Inc., 111 West 19th Street, 3rd Floor, New York, NY 10011, USA, Attn: Privacy Questions.<br/><br/> If PropCap does not satisfactorily answer your questions or concerns, you may also contact the following for advice, support or complaints:<br/><br/> PropCap’s Data Protection Officer (“DPO”) at dpo@PropCap.com ; and/or the Information Commissioner’s Office, which is PropCap’s lead supervisory authority within the European Territories.<br/><br/> 2. Alliances and Adherence We adhere to the Self-Regulatory Principles set forth by the Digital Advertising Alliance (DAA) and the European Interactive Digital Advertising Alliance (EDAA);<br/> We are members in good standing of the Network Advertising Initiative (NAI), an association dedicated to responsible data collection and its use for digital advertising. We also adhere to the NAI Code of Conduct for Web and Mobile. PropCap also adheres to the Interactive Advertising Bureau’s (IAB) Self-Regulatory Principles for Online Behavioral Advertising, and the IAB Europe OBA Framework; and<br/> We are also TAG Brand Safety Certified here.<br/><br/> 3. PropCap User Types (including Opt Out Options) Much of this Privacy Policy is divided into sections based on the way you may interact with PropCap. You are either a Site Visitor, a User and/or a Business Partner (as defined below). Please determine what user type you are. For each user type we’ve explained what information we collect and why, what cookies and other similar technologies we use, how we share such information and your rights.<br/> Site Visitors: You are a Site Visitor when you visit and interact with our web sites, web pages, interactive features, blogs and their respective contents at PropCap.com (or any derivation, such as PropCap.co.uk; PropCap.fr; PropCap.de etc.) (“Our Sites“).<br/> <br/> See more here.<br/><br/> Users: You are a User when you visit a page of a website or application of one of PropCap’s partners where the PropCap widget is installed or our recommendations are placed (“Partner Sites”). For example, if you visit https://news.sky.com/uk, www.spiegel.de or www.cnn.com, the PropCap widget is implemented on those websites. You know you are engaging with an PropCap widget when you see text referencing PropCap (e.g., “Recommended by PropCap”, “by PropCap” near recommendations If you click on the hyperlinked reference to PropCap you will see a detailed notice that enables you to navigate to PropCap’s Interest Portal and this Privacy Policy where you can opt out of personalized recommendations. In some instances, a partner may have white-label PropCap’s service for their own offering. In such an event, such partners must disclose their use of PropCap in their privacy policies.',
				button: 'I HAVE READ,UNDERSTOOD AND AGREED THE ABOVE DECLARATION.'
			},
			page2: {
				title: 'PERSONAL INFORMATION COLLECTION STATEMENT',
				content:
					'This statement is made by Propcap Technologies Limited, pursuant to and in accordance with its privacy policy, in which “we” shall mean Propcap Technologies Limited” and “you” shall mean the funder(s) who signed in the application form and the declarations thereto.<br/> We can collect, use and transfer personal information for any and all of the following business purposes:<br/>1. processing your application; other related services or products;<br/> <br/>2. facilitating payment arrangements or instructions;<br/> <br/>3. conducting identity and/or credit checks and/or debt collection;<br/> <br/>4. compilation of statistics and research analysis;<br/> <br/>5. communication with our customers and prospective customers or any members of our group or Related Parties;<br/> <br/>6. compliance with any disclosure requirements required by law and regulation;<br/> <br/>7. any other purposes as notified to you at the time of collection;<br/> <br/>8. conducting marketing and/or direct marketing activities of any other related services or products for us and/or Related Parties, pursuant to your prior consent;<br/> <br/>9. improving and furthering the provision of services by us or any members of our group and fulfilling any other purposes incidental to the above-mentioned purposes. Subject to all relevant laws and all the terms herein, in respect of the aforesaid direct marketing activity (“Direct Marketing”), (as defined in Personal Data (Privacy) Ordinance (Cap. 486) the “PDPO”), the following provisions apply:<br/> <br/>i. We intend to use and/or transfer your personal data to members of our group the, its business partners, related parties, and affiliates for Directing Marketing purposes for gain to pursue business cooperation or opportunities concerning financial, insurance, mandatory provident fund and related wealth management products or services;<br/> <br/>ii. We will not use your personal data for direct marketing purposes unless we have received your consent (which includes an indication of no objection);<br/> <br/>iii. We may use any of the following personal data for marketing products or services offered by us or our business partners: your name, your residential address, your mobile phone number, your residential phone number and your email address; and your personal data will be used for marketing and direct marketing of any of our and/or our group’s products or services via any means of transmission;<br/> <br/>iv. We may transfer your personal data to any agents, contractors or third parties who provides administrative, technology or other services to us and/or our affiliates in Hong Kong or elsewhere and who has a duty of confidentiality to the same; and<br/> <br/>v. Other purposes directly relating to any of the above. If you do not provide the required personal information, we may not be able to process your application or the service requested.<br/> <br/>You may inform us at inquiry@propcap.com.hk if you wish to opt-out of our use of your personal data for any of the Direct Marketing purposes or if you wish to opt-out of any kind or means of transmission connected with Direct Marketing.<br/> <br/>In accordance with the provisions of the PDPO, we have the right to charge a reasonable fee for the processing of any data access request. We may amend the privacy policy from time to time and the most recent version of the privacy policy shall govern<br/>',
				button: 'I HAVE READ,UNDERSTOOD AND AGREED THE ABOVE PERSONAL INFORMATION COLLECTION STATEMENT.'
			},
			page3: {
				title: 'PROFESSIONAL INVESTOR NOTICE',
				content:
					'This Professional Investor Notice is in relation to transactions entered into by you with Propcap Technologies Limited.<br/>Notice of treatment as a Professional Investor (“Notice”)<br/>You are treated as a Professional Investor by reason of your confirmation that you fall within one or more of the categories of Professional Investor prescribed in the Hong Kong Securities and Futures (Professional Investor) Rules (Cap.571D).<br/><br/><b>1. Risks and consequences of being categorized as a Professional Investor</b><br/><br/>As a consequence of our treating you as a Professional Investor, we are not required to fulfill certain requirements under the Hong Kong regulations. You acknowledge that while we may in fact do some or all of the following matters in providing services to you, we have no regulatory responsibility do so:<br/>a) to establish your financial situation, investment experience and investment objectives, except where we are providing advice on corporate finance work;<br/>b) to ensure that a recommendation or solicitation is suitable for you in the light of your financial situation, investment experience and investment objectives;<br/>c) to issue any advertisement, invitation or document made in respect of securities or structured products, or interests in any collective investment scheme, that are or are intended to be disposed of only to professional investors;<br/>d) to enter into a written agreement complying with the Code relating to the services provided to you (other than this Notice) and provide relevant risk disclosure statements;<br/>e) to inform you about our business and the identity and status of our employees and others acting on our behalf;<br/>f) to confirm promptly to you the essential features of a transaction after effecting a transaction for you;<br/>g) to make unsolicited calls (“cold calls”) in respect of marketing investment products;<br/>h) to communicate an offer to acquire or dispose of any securities issued by a body;<br/>i) to provide you with any contract notes, statements of account or receipts pursuant to the Securities and Futures (Contract Notes, Statements of Account and Receipts) Rules where such would otherwise be required, unless you instruct us to the contrary.<br/>j) to assess your knowledge of derivatives and characterize you based on your knowledge of derivatives;<br/><br/><b>2. Miscellaneous</b><br/>Except to the extent permitted by applicable laws and regulations, nothing in this Notice removes, excludes or restricts any of your rights or our obligations under the laws of Hong Kong. We may do or omit to do anything, which we believe is necessary or desirable to ensure compliance with any applicable law or regulatory requirement. You acknowledge and agree that your transactions are subject to, and you shall comply with, all applicable laws and regulatory requirements and requests.<br/><br/><b>3. Applicability</b><br/>This Notice applies to all transactions entered into by you with or through us, whether before or after the date of this Notice. If you have any questions regarding this Notice, please do not hesitate to contact inquiry@propcap.com.hk.<br/>',
				button: 'I HAVE READ,UNDERSTOOD AND AGREED THE ABOVE INFORMATION.'
			}
		},
		fsa: {
			fifthSchedule: {
				title: 'THE FIFTH SCHEDULE ABOVE REFERRED TO <br/>DECLARATION BY FUNDER',
				declaration: 'Declaration',
				para1:
					'I/We, the undersigned, the Funder of the Agreement, hereby declare that I/We fully understand the contents of the Agreement and I/ We do not wish to make any alterations, deletions or additions to the Agreement.'
			}
		},
		corporate: {
			bankAccountDetail: {
				title: 'Bank Account Information'
			},
			contactDetail: {
				title: 'Contact Person'
			},
			companyDetail: {
				title: 'Company Details',
				companyAddress: 'Registered Address',
				ciNo: 'CI No.',
				brRegNo: 'BR Registration No.',
				dateOfInCorporate: 'Date of Incorporation',
				placeOfInCorporate: 'Place of Incorporation',
				natureOfBiz: 'Nature of Business',
				shareholdingStucture: 'Shareholding Structure',
				annualSales: 'Annual Sales',
				latestNetProfit: 'Latest Net Profit',
				website: 'Website',
				netProfit: 'Net Profits for the last 3 years',
				contactPerson: {
					title: 'Title',
					nationality: 'Nationality',
					chineseName: 'Chinese Name',
					firstName: 'First Name',
					middleName: 'Middle Name',
					lastName: 'Last Name',
					gender: 'Gender',
					dob: 'Date of Birth',
					pob: 'Place of Birth',
					passportNo: 'Passport No.',
					chineseIdNo: 'Chinese ID No.',
					hkIdNo: 'HKID No.',
					countryOfTax: 'Country of Tax Residence',
					position: 'Position in the Company',
					sourceOfFund: 'Source of Fund',
					officePhone: 'Office phone Number',
					mobilePhone: 'Mobile Phone Number',
					email: 'E-mail Address',
				}
			},
			form: {
				contactPersonStep: 'Contact Person',
				notice: 'The contact person should be the company director/shareholder.'
			}
		},
		validation: {
			required: 'This is mandatory', //common for global
			requiredText: 'The text field is mandatory',
			requiredFile: 'Please upload the required file',
			zipCode: 'The length exceeds maximum allowed, 20 characters',
			inputOnlyChineseCharacters: 'Please input Chinese characters only',
			inputOnlyNumberCharacters: 'Please input number characters only',
			accountDetail: {
				required: {
					title: 'Please select your title',
					gender: 'Please select your gender',
					dob: 'Please select your date of birth',
					pob: 'Please select your place of birth',
					hkIDNo: 'Please input your HKID No.',
					hkIDNoFormat: 'Please correct your HKID Format.',
					hkIDNoFormatInput: 'Please input your HKID Format.',
					chineseID: 'Please input your Chinese ID No',
					passport: 'This is Mandatory',
					nationality: 'Please select your nationality',
					countryOfTax: 'Please select your country of Tax Residence',
					maritalStatus: 'Please select your marital status',
					sourceOfFund: 'Please select your source of fund',
					officePhoneCountryCode: 'Please select your office phone country code',
					officePhoneNumber: 'Please input your office phone number',
					mobilePhoneCountryCode: 'Please select your mobile phone country code',
					mobilePhoneNumber: 'Please input your mobile phone number',
					residenceAddressLine: 'Please input your residential address line',
					residenceAddressStreet: 'Please input your residential address street',
					residenceAddressDistrict: 'Please select your residential address District/Province',
					residenceAddressCountry: 'Please select your residential address county',
					residenceAddressZipCode: 'Please input your residential address ZIP code',
					residenceAddressLiveYear: 'Please input number of years',
					positionInCompany: 'Please input position in company',
					otherSourceOfFund: 'Please input other source of fund.',
					otherPlaceOfBirth: 'Please input other place of birth.',
					otherMaritalStatus: 'Please input other Marital Status.',
					otherTitle: 'Please input other Title.',
					maximumLiveYear: 'Maximum value is 100'
				}
			},
			employmentDetail: {
				required: {
					employmentType: 'Please select your employment type',
					employmentName: 'Please input your employment name',
					employmentOcc: 'Please input your employment occupation/position',
					employmentAddress: 'Please input your employment address',
					employmentONatureOfBiz: 'Please input your nature of Business',
					employmentStatus: 'Please select your employment status',
					employmentTypeOther: 'Please input your employment status other.',
					otherOccupation: 'Please input Other Occupation.',
					otherEmployerType: 'Please input Other Employer type',
					employer: {
						name: 'Please input employer \'s name',
						type: 'Please input employer \'s type',
						employmentOcc: 'Please select occupation/ position',
						nOfBiz: 'Please input Nature of Business',
						phoneCode: 'Please select employer\'s phone country code',
						phoneNumber: 'Please input employer\'s phone number',
						annualSalary: 'Please input Annual Salary/ Net profit',
						addressLine: 'Please input flat, floor & building name',
						streetNo: 'Please input street No. & Street Name',
						country: 'Please select country',
						district: 'Please input district/ province',
						zipCode: 'Please input ZipCode'
					}
				}
			},
			loanLendingCriteria: {
				required: {
					propType: 'Please select your property type',
					totalCommit: 'Please input total commit loan amount',
					minLoanPeriod: 'Please select minimum loan period',
					maxLoanPeriod: 'Please select maximum loan period',
					interestPaymentPeriod: 'Please select interest payment period',
					minExpectedRate: 'Please select minimum expected interest rate',
					expectedLoanPerDeal: 'Please input maximum expected loan per deal',
					proposedLoanCurrency: 'Please select maximum proposed loan currency',
					propertyCountryPreference: 'Please select property country preference',
					totalCommittedHaveGreaterThanMaxLoanPerDeal: 'Total Committed Loan have to greater than Max loan per deal'
				}
			},
			bankAccount: {
				required: {
					name: 'Please input bank name',
					swift: 'Please input swift code',
					address: 'Please input bank address',
					accountNum: 'Please input account number',
					accountName: 'Please input account name',
					onlyCharacters: 'Please enter alphabets only',
					onlyNumber: 'Please input only number'
				}
			},
			companyDetail: {
				websiteRequired: 'Please input your company website.',
				websiteFormatRequired: 'Please input correct website format.',
				profitInYearRequired: 'Please input your company revenue.',
				yearRequired: 'Please select your company year.',
				sameYearValidate: 'Can not choose the same year'
			},
			financialDetail: {
				requiredIfResidentialPresent: 'Please input the value if residential/ investment mortgages presented'
			}
		}
	},
	onboardingStatus: {
		InCompleted: 'InCompleted',
		draft: 'Draft',
		pendingApproval: 'Pending Approval',
		approved: 'Approved',
		rejected: 'Rejected',
		declined: 'Declined',
		signFSA: 'Signed FSA',
		investADeal: 'Invest a deal',
		submitAMortgageApplication: 'Submit a mortgage application'
	},
	eform: {
		firstNameNotMatched: 'First Name is not matched',
		lastNameNotMatched: 'Last Name is not matched',
		middleNameNotMatched: 'Middle Name is not matched'
	},
	crPage: {
		title: 'Change Information',
		crTypeTitle: 'Choose the Information you want to change',
		existing: 'Existing',
		new: 'New',
		typeHere: 'Type here',
		documentUpload: 'Document upload',
		rejectRemark: 'Reject Remark',
		crTypes: {
			en: 'English Name',
			cn: 'Chinese Name',
			contactNumber: 'Contact Number',
			emailAddr: 'Email Address',
			residentialAddr: 'Residential Address',
			mailingAddr: 'Mailing Address',
			nationality: 'Nationality',
			bankAccount: 'Bank Account Details',
			countryOfTax: 'Country of Tax Residence',
			sourceOfFund: 'Source of Fund',
			employmentDetails: 'Employment Details',
			companyName: 'Company Name',
			passportNo: 'Passport No.',
			chineseIdNo: 'Chinese ID No.',
			hkIdNo: 'HKID No.',
			chineseIdEffectiveDate: 'Chinese ID Effective Date',
			chineseIdExpiryDate: 'Chinese ID Expiry Date',
			chineseIDRegistrationAddress: 'Address declared upon Chinese ID registration',
			bankCardNumber: 'Bank Card Number',
		},
		corporateCrTypes: {
			en: 'Contact Person’s English Name',
			cn: 'Contact Person’s Chinese Name',
			contactNumber: 'Contact Person’s Contact Number',
			emailAddr: 'Email Address',
			residentialAddr: 'Contact Person’s Residential Address',
			mailingAddr: 'Contact Person’s Mailing Address',
			nationality: 'Contact Person’s Nationality',
			bankAccount: 'Bank Account Details',
			countryOfTax: 'Contact Person’s Country of Tax Residence ',
			sourceOfFund: 'Contact Person’s Source of Fund ',
			companyName: 'Company Name'
		},
		submitted: 'Your change requests have been submitted',
		deleteCrConfirmTitle: 'Are you sure to delete change request?',
		deleteItemDescription: 'Your change request will be permanently removed',
		deleteItemSuccess: 'Success, Change request have been removed',
		validation: {
			cn: 'Please input Chinese Name.',
			officePhone: 'Please input Office Phone.',
			officePhoneCountryCode: 'Please input Office Phone Country Code.',
			mobilePhone: 'Please input Mobile Phone.',
			mobilePhoneCountryCode: 'Please input Mobile Phone Country Code.',
			mailingAddressLine: 'Please input your Mailing address line',
			mailingAddressStreet: 'Please input your Mailing address street',
			mailingAddressDistrict: 'Please select your Mailing address District/Province',
			mailingAddressCountry: 'Please select your Mailing address county',
			mailingAddressZipCode: 'Please input your Mailing address ZIP code'
		},
		history: {
			changeOf: 'Change of {{type}}',
			submittedAt: 'Submitted date: {{date}}',
			status: {
				waiting: 'Waiting For approval',
				accepted: 'Approved',
				rejected: 'Rejected'
			}
		}
	},
	mortgageDeal: {
		searchByDealNo: 'Search by Deal No.',
		country: 'Country',
		loanPeriod: 'Loan Period',
		greenMortgage: 'Green Mortgage',
		securityValue: 'Security Value',
		loanRate: 'Loan Rate',
		dealNo: 'Deal no.',
		leftToInvest: 'Left to invest',
		investNow: 'Invest Now',
		EPCRating: 'EPC Rating',
		BELSRating: 'BELS Rating',
		annualReturn: 'Annual Return',
		loanAmount: 'Loan Amount',
		messageNotFoundTitle: 'Sorry! No result found ;(',
		messageNotFound: "We couldn't find match for your search. Please try another search",

		resendInvitationEmail: 'Resend invitation email',
		ResendInvitationEmailToGuarantor: 'Resend invitation email to Guarantor.',
		list: 'Mortgage Application List',
		resend: 'Resend',
		DealNumber: 'Deal no. ',
		optionFilter: {
			AllMortgageDeal: 'All Mortgage Deal',
			ApplicationInProgress: 'Application In Progress',
			Approved: 'Approved',
			Decline: 'Decline',
			Closed: 'Closed'
		},
		actionButton: {
			edit: 'Edit',
			pay: 'Pay',
			choose: 'Choose',
			view: 'View',
			submit: 'Submit',
			sign: 'Sign',
			preview: 'Preview',
			schedule: 'Schedule',
			resubmit: 'Resubmit'
		},
		summary: {
			ProposalLoanAmount: 'Proposal Loan Amount: ',
			LoanRate: 'Loan Rate: ',
			InterestPerYear: 'Interest / Year: ',
			LoanPeriod: 'Loan Period: ',
			LTV: 'LTV: ',
			InterestPaymentPeriod: 'Interest Payment Period: '
		},
		proposalTable: {
			loanProposal: 'LOAN PROPOSAL',
			ltv: 'LTV',
			loanRate: 'LOAN RATE',
			loanPeriod: 'LOAN PERIOD',
			interestPaymentPeriod: 'INTEREST PAYMENT PERIOD',
			proposedLoanAmount: 'PROPOSED LOAN AMOUNT',
			interestPerYear: 'INTEREST \n/ YEAR',
			lastUpdatedDate: 'Last updated date: ',
			loanPeriodUnit: 'Months',
			interestPaymentPeriodUnit: 'Months',
			investConfirmationModal: {
				title: 'Confirm invest?',
				content: 'Are you sure you want to invest this plan?',
				back: 'Back',
				confirmAndContinue: 'Confirm and continue'
			},
			counterFunder: {
				title: 'New Counter proposal confirmation',
				content: 'Are you sure to submit new counter proposal?',
				back: 'Back',
				confirmAndContinue: 'Confirm and continue'
			}
		},
		securedPropertyDetail: {
			title: 'Secured Property Details',
			tenure: 'Tenure',
			remainingLeaseTerm: 'Remaining Lease Term',
			ownershipType: 'Ownership Type',
			condition: 'Condition',
			propertyType: 'Property Type',
			size: 'Size',
			numberOfBedroom: 'Bedroom',
			numberOfBathroom: 'Bathroom',
			yearBuild: 'Year Built',
			situation: 'Status',
			spExchangedDate: 'S&P Exchanged Date',
			targetCompletionDate: 'Target Completion Date',
			rentalIncome: 'Rental Income (Year)',
			groundRent: 'Ground Rent (Year)',
			serviceCharge: 'Service Charge (Year)'
		},
		valuationDetail: {
			title: 'Valuation Detail',
			valuationDate: 'Valuation Date',
			surveyorName: 'Surveyor Name',
			marketRent: 'Market Rent',
			valuationValue: 'Valuation Value'
		},
		borrowerGuarantorBackground: {
			title: 'Borrower/Guarantor Background',
			borrower: 'Borrower',
			guarantor: 'Guarantor',
			nationality: 'Nationality',
			employment: 'Employment',
			occupation: 'Occupation',
			relationshipWithBorrower: 'Relationship with Borrower'
		},
		financialBackground: {
			title: 'Financial Background',
			totalIncome: 'Total Income (include Rent)',
			totalExpense: 'Total Expenses (exclude interest)',
			grossAsset: 'Gross Assets',
			grossLiabilities: 'Gross Liabilities'
		},
		creditHistory: {
			title: 'Credit History',
			anyloanDefault: 'Any kind of Loan Default',
			debtPenalties: 'Debt Penalties',
			criminalExp: 'Criminal Offence Experiences'
		},
		borrowerAndGuarantor: 'Borrower and Guarantor',
		requestForm: {
			title: 'Mortgage Deal Form',
			message: {
				confirmForm: 'You have confirm Borrower Request Successfully.',
				mortgageDealDetails: 'You have save Mortgage Deal Details Successfully.',
				inviteAGuarantor: 'You have save Invite A Guarantor Successfully.',
				submitSuccess: 'Thank you for requesting the Mortgage Deal. Your request is now confirmed!'
			},
			steps: {
				borrowerRequest: 'Borrower Request',
				mortgageDealDetails: 'Mortgage Deal Details',
				inviteGuarantor: 'Invite a Guarantor',
				supportingDocument: 'Supporting Documents'
			},
			borrowerRequest: {
				EmploymentDetails: 'Employment Details',
				PersonalAssetsAndLiabilities: 'Personal Assets and Liabilities',
				formConfirm: {
					ConfirmBorrowerRequest: 'Confirm Borrower Request',
					description: 'Please make sure all the information in Borrower Request is up-to-date.',
					CRButton: 'Change Request',
					confirmButton: 'Confirm and continue',
					confirmGuarantorRequest: 'Confirm Guarantor Request',
					confirmGuarantorRequestText:
						'Please make sure all the information in Guarantor Request is the latest version. Submit a change request if any need edit',
					confirmGuarantorRequestText1:
						'Please make sure all the information in Guarantor Request is the latest version.'
				}
			},
			mortgageDealDetails: {
				loanDetails: 'Loan Details',
				borrowAmount: 'Borrow Amount',
				proposedCurrency: 'Proposed Currency (can choose more than one)',
				loanTerm: 'Loan Term',
				interestPaymentPeriod: {
					title: 'Interest Payment Period',
					value: {
						_3months: '3 Months',
						_6months: '6 Months'
					}
				},
				useOfFunds: {
					title: 'Use of Funds',
					value: {
						newPurchaseSelfUse: 'New Purchase-Self Use',
						NEW_PURCHASE_BTL: 'New Purchase-BTL',
						REFINANCE_SELF_USE: 'Refinance-Self Use',
						REFINANCE_BTL: 'Refinance-BTL',
						OTHERS: 'Others'
					}
				},
				securityDetails: 'Security Details',
				propertyType: 'Property Type',
				noOfBedroom: 'No. of Bedroom',
				studio: 'Studio',
				status: 'Status',
				vacant: 'Vacant',
				tenanted: 'Tenanted',
				condition: 'Condition',
				new: 'New',
				liveable: 'Liveable',
				requireRenovation: 'Require Renovation',
				address: 'Address',
				purchasePrice: 'Purchase Price',
				currentOrExpectedRentPerMonth: 'Current or Expected Rent/Month',
				groundRentPerMonth: 'Ground Rent/Month',
				buildingManagementFeePerMonth: 'Building Management Fee / Month',
				holdingType: 'Holding Type',
				freeHold: 'Free hold',
				leaseHold: 'Lease hold',
				unexpiredTermOfLease: 'Unexpired term of lease',
				ownership: {
					title: 'Ownership',
					jointTenancy: 'Joint Tenancy',
					tenancyInCommon: 'Tenancy in common',
					individualOwnership: 'Individual ownership',
					other: 'Others'
				},
				question1: 'Any mortgage approved by other Bank(s) or Organization(s) for the security?',
				question2: 'In this application, is it a second mortgage for the security?',
				tooltipQuestion1: 'If the answer is “Yes”, please provide proof of document(s).',
				solicitorDetails: 'Solicitor Details',
				companyName: 'Company Name',
				companyAddress: 'Company Address',
				contactPerson: 'Contact Person',
				contactNumber: 'Contact Number',
				emailAddress: 'Email Address',
				propertyCompanyManagement: 'Property Management Company',
				thirdPartyReferral: 'Third Party Referrers',
				tooltipThirdPartyReferral:
					'If you are referred by third parties, please also upload the third party agreements in the supporting document session.',
				doYouHaveAReferral: 'Are You Referred By a Third Party?',
				referralList: 'Referrer Information',
				companyNameOrIndividualName: 'Company Name/ Individual Name',
				none: 'None'
			},
			inviteGuarantor: {
				title: 'Invite a Guarantor',
				name: 'Name',
				relationshipWithBorrower: 'Relationship with Borrower',
				emailAddress: 'Email Address',
				proofOfRelationship: 'Proof of Relationship',
				guarantor: 'Guarantor',
				parents: 'Parents',
				Spouse: 'Spouse',
				Couple: 'Couple',
				Grandparents: 'Grandparents',
				Sisters: 'Sisters',
				Brothers: 'Brothers',
				Fiance: 'Fiance',
				Fiancee: 'Fiancee',
				Friends: 'Friends',
				BusinessPartners: 'Business Partners',
				Others: 'Others',
				resendTomorrow: '* You can only resend email once a day. Please try tomorrow.',
				resendMessage: 'Resend email to guarantor successfully.'
			},
			validate: {
				borrowAmount: 'Please input Borrow Amount.',
				loanTerm: 'Please input Loan Term.',
				interestPaymentPeriod: 'Please choose Interest Payment Period.',
				useOfFunds: 'Please choose Use of Funds.',
				otherUseOfFunds: 'Please input Use of Funds Other.',
				propertyType: 'Please Select Property Type.',
				noOfBedroom: 'Please Select Number of Bedroom.',
				status: 'Please choose Status.',
				condition: 'Please Select Condition.',
				purchasePrice: 'Please input Purchase Price.',
				currentOrExpectedRentPerMonth: ' Please input Current or Expected Rent/Month',
				groundRentPerMonth: 'Please input Ground Rent/Month.',
				buildingManagementFeePerMonth: 'Please input Building Management Fee / Month.',
				holdingType: 'Please choose Holding Type.',
				unexpiredTermOfLease: 'Please input Unexpired term of lease',
				ownership: 'Please choose Ownership.',
				otherOwnership: 'Please input Other Ownership.',
				question: 'Please answer question.',
				doYouHaveAReferral: 'Please choose a Third Party Referral.',
				companyNameOrIndividualName: 'Please input Company Name/ Individual Name.',
				address: 'Please input Address.',
				name: 'Please input Guarantor Name.',
				relationship: 'Please select Relationship with borrower.',
				emailAddress: 'Please input Email Address',
				proofOfRelationship: 'Please upload Proof of Relationship.',
				residenceAddressDistrict: 'Please input your residential address District/Province',
				formatAmount: 'Please the correct Amount.',
				formatMonth: 'Please the correct Months.',
				formatPhoneNumber: 'Please the correct The Contact number.',
				pleaseChooseInviteAGuarantor: 'Please choose Invite a Guarantor.',
				borrowerCanNotBecomeAGuarantor: 'You Can Not Become Your Own Guarantor.',
			},
			supportingDocument: {
				reservationFormOrMemorandumOfSale: 'Reservation Form or Memorandum of Sale',
				ExistingMortgageStatementRentRoll: 'Existing Mortgage Statements/Rent Roll',
				ValuationReport: 'Valuation Report',
				ThirdPartyAgreement: 'Third Party Agreement (if any)',
				GuarantorFile: '',
				reportOnTitleOrTitleDeed: 'Report on Title / Title Deed ',
				uploadFileSuccess: 'Uploaded File.',
				saveDraft: 'Save Draft A Mortgage Deal Application successfully.'
			}
		},
		eForm: {
			title: 'Disclosure of the existence of third parties by intending borrower [Licensing Condition 1(b)]',
			confirmationFrom: 'Confirmation From',
			to: 'To: Propcap Technologies Limited ',
			no: 'I / We, ',
			holderOf: 'holder of',
			hkIdentity: 'Hong Kong Identity Card No.',
			cnIdentity: 'Chinese Identity Card No.',
			passportNo: 'Passport No.',
			corporateNo: 'BR Certificate No.',
			companyNumber: '/ [Company Number ',
			address: 'at (address ',
			refer: ') refer to my / our application to you for a loan and hereby confirm that : ',
			first: '(1) | / We',
			radioOption1: '| / We have entered into or signed an agreement with a third party',
			radioOption2:
				'| / We have not entered into or signed any agreement with any third party] for or in relation to the procuring, negotiation, obtaining or application of the loan, guaranteeing or securing the repayment of the loan (other than any agreement with solicitors instructed by me / us for the provision of legal services solely)',
			second: 'The name and address of the third party are as follows:',
			descriptionForSecondRole:
				'| / We hereby provide a copy of each of the agreement with the third party or parties and understand that such agreement(s) will be attached to the loan agreement.',
			important: 'IMPORTANT NOTE: ',
			importantNote:
				'Please not that it is an offense for a person to fraudulently induce a money lender to lend money by false or misleading statement or dishonest concealment of material facts.',
			importantNote2:
				'You should make full and honest disclosure of the above information on the involvement of any third parties in relation to the loan for the protection of your own interests.',
			submitButton: 'I AGREE THE PERSONAL INFORMATION COLLECTION STATEMENT'
		},
		mortgageDealApplication: {
			mortgageDealApplicationWasPending: 'Mortgage Application was pending',
			reason: 'Mortgage Application ({{dealNumber}}) was pending due to Documents / Information is missing.',
			mortgageApplicationWasClosed: 'Declined by PropCap',
			reasonWasDeclined: 'Since the Mortgage form was declined by PropCap, the mortgage application was closed.',
			cloneAndResubmitTheFormAgain: 'Clone and resubmit the form again'
		}
	},
	investment: {
		title: 'Investment',
		investmentList: {
			title: 'Investment List'
		},
		optionFilter: {
			allInvestments: 'All Investments',
			investmentInProgress: 'Investment in progress',
			underRepayment: 'Under Repayment',
			decline: 'Decline',
			closed: 'Closed'
		},
		borrower: {
			title: 'Mortgage deal proposal',
			proposalList: 'Proposal List',
			accept: 'Accept',
			acceptAll: 'Accept All',
			rejectAll: 'Reject All',
			proposalItem: 'Proposal {{idx}}',
			rejectAllSuccess: 'All proposals were rejected',
			accepted: 'Proposal was accepted',
			rejectAllConfirmTitle: 'Are you sure to reject all proposals?',
			rejectAllConfirm: 'Are you sure to reject all proposals?',
		}
	},
	guarantee: {
		title: 'Guarantee',
		guaranteeList: {
			title: 'Guarantee List'
		},
		view: {
			borrowerName: 'Borrower Name:',
			borrowerAmount: 'Borrower Amount:',
			loanTerm: 'Loan Term:',
			borrowerEmail: 'Borrower Email:',
			interestPaymentPeriod: 'Interest Payment Period:',
			useOfFunds: 'Use of Funds:'
		}
	},
	resubmitPopup: {
		borrowerTitle: 'Borrower request was rejected',
		funderTitle: 'Funder request was rejected',
		borrowerDescription: 'Borrower request was rejected due to Documents / Information is missing.',
		funderDescription: 'Funder request was rejected due to Documents / Information is missing.',
		note: 'Supporting Documents: Proof of Deposit was not clear enough, please resubmit a clear photo.',
		editToResubmit: 'Edit to Resubmit'
	},
	sessionHasExpired: 'Your session has expired.',
	documentDescription: {
		identities: '(Acceptable file formats: .bmp, .pdf, .jpg, .jpeg, .gif, .tif, File size: Between 50 kb and 5 mb.)',
		selfie: '(Acceptable file formats: .png, .jpg, .jpeg, .heic, File size: Between 50 kb and 5 mb.)',
		residentialProof: '(Acceptable file formats: .pdf, .png, .jpg, .jpeg, File size: less than 5 mb.)',
		commonFile:
			'(Acceptable file formats: .xls, .xlsx, .doc, .docx, .txt, .vsdx, .pdf, .jpg, File size: less than 5 mb.)'
	},
	mortgage: {
		conditionalOfferLetter: {
			title: 'Conditional Offer Letter',
			description:
				'This Conditional Offer Letter Is Provided Strictly Subject To Satisfactory Completion By Propcap Technologies Limited (Propcap) Of Full Due Diligence, Credit Approval And Legal Documentation. Propcap Is Not Obliged To Provide Funding On These Terms Or At All. If, After 90 Days From The Date Of Issue Of This Conditional Offer Letter ,The Proposed Loan/Facility Has Not Draw Drawn, These Terms Will Expire And Propcap Is Under No Obligation To Issue Revised Terms Following Such Expiry. This Conditional Offer Letter (Including The Attached Terms And Conditions) Shall Become Legally Binding Only Upon Signature By The Borrower.',
			readAndSignBtn: 'READ AND SIGN',
			conditionalOfferLetterFee: 'Conditional Offer Letter Handling Fee',
			payOfferFeeBtn: 'PAY OFFER ACCEPTANCE FEE',
			paymentMethod: 'Payment Method',
			paymentProof: 'Payment Proof',
			pfsNum: 'FPS Number'
		},
		paymentMethods: {
			qf: 'QF Pay',
			paypal: 'Paypal',
			bankTransfer: 'Bank Transfer',
			accountName: 'Account Name',
			accountNo: 'Account No.',
			bankName: 'Bank Name',
			bankAddress: 'Bank Address',
			swiftCode: 'Swift Code',
			paymentError: 'Could not init the payment',
			bankTransferSubmitted: 'Your payment information have been recorded',
			paymentProcessing: 'Your transaction is being processed',
			paymentCaptured: 'Your transaction have been captured',
			title: 'Offer Acceptance Fee'
		},
		offerLetter: {
			mainText:
				'THIS CONDITIONAL OFFER LETTER IS PROVIDED STRICTLY SUBJECT TO SATISFACTORY COMPLETION BY PROPCAP TECHNOLOGIES LIMITED (PROPCAP) OF FULL DUE DILIGENCE, CREDIT APPROVAL AND LEGAL DOCUMENTATION. PROPCAP IS NOT OBLIGED TO PROVIDE FUNDING ON THESE TERMS OR AT ALL. IF, AFTER 90 DAYS FROM THE DATE OF ISSUE OF THIS CONDITIONAL OFFER LETTER ,THE PROPOSED LOAN/FACILITY HAS NOT DRAW DRAWN, THESE TERMS WILL EXPIRE AND PROPCAP IS UNDER NO OBLIGATION TO ISSUE REVISED TERMS FOLLOWING SUCH EXPIRY. THIS CONDITIONAL OFFER LETTER (INCLUDING THE ATTACHED TERMS AND CONDITIONS) SHALL BECOME LEGALLY BINDING ONLY UPON SIGNATURE BY THE BORROWER.',
			borrowerName: 'Borrower Name',
			issueDate: 'Conditional Offer Letter Issue Date',
			drawdownDate: 'Proposed Drawdown Date',
			expiryDate: 'Offer Expiry Date',
			investmentProperty: 'Captioned Investment Property',
			refID: 'Reference ID',
			keyTerms: 'Key Terms',
			purpose: 'Purpose',
			purposeText: 'The loan shall be used to finance the purchase of the captioned investment property.',
			grossLoanAmt: 'Gross Loan Amount',
			expectedDeductions: 'Expected Deductions',
			platformFee: 'Platform Usage Fee ({{platformUsageFee}}% of Loan Amount)',
			monthInterestRetentions: '{{interestRetentions}} months Interest Retentions',
			disbursements: 'Disbursements',
			feePlusVAT: 'Legal Fee plus VAT & disbursements',
			legalMortgageIncludeVAT: 'Legal Mortgage include VAT & disbursements',
			netDrawdown: 'Net Advance at Drawdown',
			cancellationFee: 'Cancellation Fee',
			cancellationFeeText:
				'1% of loan amount (minimum HKD 15,000.00) will be charged after loan contract is exchanged but the loan has not been drawdown',
			interestsRetentionBuffer: 'Interests Retention Buffer',
			interestsRetentionBufferText:
				'A retention buffer equivalent to <b>{{months}}</b> months interest payments <b>{{amount}}</b> is to be deducted at drawdown, which may be used to service payments due on this loan as required.',
			loanPeriod: 'Loan Period',
			loanPeriodTex: '<b>{{loanPeriod}}</b> months after drawdown',
			principalRepaymentDate: 'Principal Repayment Date',
			principalRepaymentDateText: '<b>{{loanPeriod}}</b> months after drawdown',
			loanRateAndDefault: 'Loan Rate and Default Rate',
			loanRate: 'Loan Rate',
			defaultRate: 'Default Rate',
			perAnnum: '<b>{{rate}}%</b> per annum',
			year: 'Year',
			interestRepayments: 'Interest Repayments',
			interestRepaymentsText:
				'Interest only payments of <b>{{interestRetentionsAmount}}</b> payable on every <b>{{interestRetentionsMonths}}</b> month of the loan period followed by a final repayment of <b>{{interestRepaymentMonths}}</b> at repayment date.',
			secToBeTaken: 'Security to be taken',
			firstLegalCharge: 'First Legal Charge over property',
			personalGuarantee: 'Personal Guarantee',
			debenture: 'Debenture',
			insurance: 'Insurance',
			insuranceText:
				'Evidence of a comprehensive insurance policy on the property with our interest noted covering at least the reinstatement amount recommended by the charted surveyor and to be index linked.',
			administrativeFee: 'Administrative Fee',
			administrativeFeeText:
				'<b>HKD 5,000.00</b> Payable when conditional offer letter is signed and accepted.<br><b>HKD 3,000.00</b> Payable on the beginning of each new contractual year.',
			earlyRepayment: 'Early Repayment',
			earlyRepaymentText:
				'Borrower can return the whole principal amount or partial amount at any time with no penalty.',
			costs: 'Costs',
			costsText:
				'All costs, disbursements, imposts, etc., in connection with this loan, the investigation, documentation, perfection, registration, completion, enforcement and release of the security, including all legal and other professional costs, as well as our handling fee up discharge, are to be borne by you on a full indemnity basis.',
			solicitors: 'Solicitors',
			solicitorsText:
				'The legal charge is done through {{solicitors}}. They are to be fully satisfied with the title of all security provided.',
			optToRenew: 'Option to Renew',
			otpToRenewText:
				'If the borrower is intended to renew the loan, he shall give Propcap notice in writing not later than 2 months before the repayment date. It is subject to credit check and enter new loan agreement. 1% of loan amount of renew fee and all other costs will be applied.',
			dueDiligence: 'Due Diligence',
			dueDiligenceText:
				'Further Due Diligence is to be carried out and is subject to final Credit Approval. The personal information we have collected from you will be shared with fraud prevention agencies who will use it to prevent fraud and money-laundering and to verify your identity. If fraud is detected, you could be refused certain services, finance or employment. Further details of how your information will be used by us and these fraud prevention agencies <br>• Completion of Anti Money Laundering/ “Know Your Customer” formalities, including six-months Bank Statements. <br>• Satisfactory Credit Searches. <br>• Satisfactory financial information in relation to the borrower.',
			conditionsPrecedent: 'Conditions Precedent',
			conditionsPrecedentText:
				'a) Satisfactory AML/KYC checks in respect of the Borrowers / Directors / Shareholders.<br/>b) Clear credit searches against the Borrowers / Directors / Shareholders.<br>c) Satisfactory completion of all stated security requirements.<br>d) Formal, independent valuations addressed to Propcap Technologies Limited from time to time by a RICS qualified valuer confirming market values of the property.<br>e) 6 months copies of the business and personal bank statements revealing satisfactory conduct.<br>f) Propcap due diligence to be satisfied that loan can be serviced.<br>g) Property to have been completed & suitable for occupation prior to release of funding.<br>h) Confirmation that a UK Agent has been appointed to administer the property.<br>i) Satisfactory EPC to be provided.<br>j) Satisfactory of Assets proof.',
			covenants: 'Covenants',
			covenantsText:
				'Loan to Value – The Loan must not exceed <b>{{ltvValue}}%</b> of the total Prop-erty Value on each Valuation Date against total outstanding charges.',
			miscellaneous: 'Miscellaneous',
			miscellaneousText:
				'We recommend that before signing and returning the acceptance you show this letter to your solicitors and take independent advice on the consequences, liabilities and the possibility of tax liabilities resulting from this arrangement.',
			law: 'Law',
			lawText:
				'This Agreement and any dispute arising out of or in connection with it or its subject matter shall be governed by and construed in accordance with Hong Kong Law.',
			repaymentCharge: 'Repayment Charge',
			repaymentChargeText: 'HKD 78.00 / USD 10.00 / GBP 7.50 / JPY 1,170.00',
			offerAcceptanceFee: 'Offer Acceptance Fee',
			youManyRequired:
				'You may be required, in certain circumstances, to take independent legal advice before entering into the loan.',
			allFeeArePayable: 'All Fees are payable by bank transfer to:',
			confirmText1:
				'I/We confirm that I/we have considered the attached terms and conditions, and confirm that I/we intend to be legally bound by the terms set out therein.',
			confirmText2:
				'I / We further confirm that I /we agree to pay platform membership annual fee with particulars as set out in offer letter',
			btn: 'I CONFIRMED AND SIGNED THE CONDITIONAL OFFER LETTER',
			legalMortgageIncludeVATinform: ' will inform your solicitor',
			signOfferLetterSuccessfully: 'Signed Offer letter'
		},
		investmentDetail: {
			envImpactionTitle: 'Environmental Impact',
			epcRate: 'EPC Rating',
			epcRateHint: 'To be defined',
			bels: 'BELS',
			belsHint:
				'Building-Housing Energy-efficiency Labeling System (BELS) measures the energy efficiency of the Japanese properties. It is endorsed by the government andcertified by a third-party evaluation organization. BELS star ratings are given to properties and are represented on a scale from 1 (least efficient) to 5 (most efficient). The national standard requires at least 2 stars.',
			savingC02: 'Save {{co2Saving}} CO<sup>2</sup>',
			belsRatingEnergy: 'Save <b>{{energySaving}} %</b> Energy',
			belsEnergyReduce: '<b>{{energySaving}}</b> energy than Japan’s standard',
			propProduce: 'This property produces <b>{{produceCo2}}</b> tonnes of CO<sup>2</sup>',
			avgProduces: 'An average household produces <b>{{tonesCo2}}</b> tonnes of  CO<sup>2</sup>',
			validUntil: 'Valid until',
			secValue: 'Security Value'
		}
	},
	funderInvestment: {
		walletTabTitle: 'Funder wallet',
		investmentTabTitle: 'Investment List',
		filter: {
			all: 'All investments',
			inprogress: 'Investment in progress',
			underRepayment: 'Under Repayment',
			decline: 'Decline',
			closed: 'Close',
		}
	}
};

export default en;
